module.exports = __webpack_public_path__ + "img/hyperlink-icon.499bdf36.svg";